export const USER_SLICE_LABEL = "auth";
export const INDEX_SLICE_LABEL = "index";

export const REQUEST_API = 'REQUEST_API';
export const SUCCESS_API = "SUCCESS_API";
export const FAILURE_API = "FAILURE_API";